import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteApp($deleteAppId: ID!, $zoneId: ID!, $tenantId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteApp(id: $deleteAppId) {
          id
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteAppMutation,
  void,
  graphql.schema.DeleteAppMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
